// usePackingsXL - Sprint 44 Fase 3 Vista 7.
// Hook lista de packings con filtro estado + paginacion + msg auto-dismiss.
// Reusa packingService legacy.
import { useCallback, useEffect, useRef, useState } from 'react';
import * as svc from '../../packing/services/packingService';

const DEFAULT_PER_PAGE = 25;
const MSG_AUTO_DISMISS_MS = 4000;

export default function usePackingsXL() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(DEFAULT_PER_PAGE);
  const [estado, setEstado] = useState('');
  const [msg, setMsg] = useState(null);

  const msgTimer = useRef(null);
  const pushMsg = useCallback((kind, text) => {
    if (msgTimer.current) clearTimeout(msgTimer.current);
    setMsg({ kind, text });
    msgTimer.current = setTimeout(() => setMsg(null), MSG_AUTO_DISMISS_MS);
  }, []);
  useEffect(() => () => {
    if (msgTimer.current) clearTimeout(msgTimer.current);
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setErr(null);
    try {
      const r = await svc.listPackings({ page, per_page: perPage, estado });
      setItems(r.items || []);
      setTotal(r.total || 0);
    } catch (e) {
      setErr((e && e.message) || 'Error al cargar packings');
      setItems([]); setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [page, perPage, estado]);

  useEffect(() => { load(); }, [load]);

  const resetAndSetEstado = useCallback((v) => { setPage(1); setEstado(v); }, []);

  const totalPages = Math.max(1, Math.ceil((total || 0) / (perPage || 1)));
  const canPrev = page > 1;
  const canNext = page < totalPages;

  return {
    items, total, loading, err,
    page, perPage, setPage, setPerPage,
    totalPages, canPrev, canNext,
    estado, setEstado: resetAndSetEstado,
    msg, pushMsg, clearMsg: () => setMsg(null),
    load,
  };
}
